module.exports = __webpack_public_path__ + "assets/img/f36a3cc090096eb186e01f4200895639.svg";